<template>
  <el-dialog
    class="mode"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :title="title"
    top="5vh"
    width="1024px"
    :visible.sync="show"
    append-to-body
  >
    <vab-form ref="form" :model="form" :rules="rules">
      <vab-row
        v-for="(row, index) in form.scheduleAdjDetailModelList"
        :key="index"
        class="row_box new_workInfo"
      >
        <vab-col :span="24" class="word_box nopadding notop border_none">
          <vab-row class="flex_center_align margin_auot_3">
            <vab-col class="flex_center_align picker_label">
              <span class="tz_title">日程</span>
            </vab-col>
            <vab-col class="date_picker">
              <div class="flex_start tz_right flex_center_align">
                <vab-date-picker
                  type="date"
                  :label-show="false"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  validate="required"
                  label-error="日程"
                  :prop="`scheduleAdjDetailModelList.${index}.startDateTime`"
                  :end-date-prop="`scheduleAdjDetailModelList.${index}.endDateTime`"
                  :clearable="false"
                  @change="(value) => changeWattingDate(row, index, value)"
                />
                <div class="line">～</div>
                <vab-date-picker
                  type="date"
                  :label-show="false"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  validate="required"
                  label-error="日程"
                  :prop="`scheduleAdjDetailModelList.${index}.endDateTime`"
                  :start-date-prop="`scheduleAdjDetailModelList.${index}.startDateTime`"
                  :clearable="false"
                  @change="(value) => changeWattingDate(row, index, value)"
                />
              </div>
            </vab-col>
          </vab-row>
          <vab-row class="margin_8">
            <vab-col class="flex_center_align picker_label">
              <span class="tz_title">時間</span>
            </vab-col>
            <vab-col class="time_picker">
              <div class="flex_start flex_center_align">
                <vab-time-picker
                  :prop="`scheduleAdjDetailModelList.${index}.startTime`"
                  format="HH:mm"
                  value-format="HH:mm"
                  :value-format-sss="true"
                  :disabled="row.disabled"
                  :end-date-prop="`scheduleAdjDetailModelList.${index}.endTime`"
                ></vab-time-picker>

                <div class="line">～</div>
                <vab-time-picker
                  :prop="`scheduleAdjDetailModelList.${index}.endTime`"
                  format="HH:mm"
                  value-format="HH:mm"
                  :value-format-sss="true"
                  :disabled="row.disabled"
                  :start-date-prop="`scheduleAdjDetailModelList.${index}.startTime`"
                ></vab-time-picker>
                <div class="end_box">
                  <vab-checkbox
                    label="終日"
                    :prop="`scheduleAdjDetailModelList.${index}.dayFlag`"
                    :code-enum="$divisions.validFlgEnum"
                    :disabled="row.checkDisabled"
                    :class="row.checkDisabled ? 'checkbox_disabled' : ''"
                    @change="(value) => changeDayFlag(value, row)"
                  ></vab-checkbox>
                </div>
              </div>
            </vab-col>
          </vab-row>
          <div class="line_boder margin_8"></div>
          <vab-row v-for="(item, s) in hbList" :key="s" class="margin_8">
            <vab-col class="flex_center_align picker_label">
              <span class="tz_title">{{ item.name }}</span>
            </vab-col>
            <vab-col>
              <div class="flex_start flex_center_align">
                <div class="radio_box">
                  <vab-radio-group
                    :ref="item.prefix + index"
                    :prop="`scheduleAdjDetailModelList.${index}.${item.prefix}ExistFlag`"
                    :code-enum="$divisions.existFlag2Enum"
                    filter="existFlag2"
                    class="margin_0"
                  />
                </div>
                <div class="flex_start flex_center_align time_picker_no">
                  <vab-time-picker
                    class="margin_0 work_time"
                    :prop="`scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`"
                    format="HH:mm"
                    value-format="HH:mm"
                    :value-format-sss="true"
                    :validate="validateStartTime(row, item, index)"
                    :end-date-prop="`scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`"
                    :disabled="!checkEnumFlag(row[item.prefix + 'ExistFlag'])"
                  ></vab-time-picker>
                  <div class="line">～</div>
                  <vab-time-picker
                    class="margin_0 work_time"
                    :prop="`scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`"
                    format="HH:mm"
                    value-format="HH:mm"
                    :value-format-sss="true"
                    :validate="validateStartTime(row, item, index)"
                    :start-date-prop="`scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`"
                    :disabled="!checkEnumFlag(row[item.prefix + 'ExistFlag'])"
                  ></vab-time-picker>
                </div>
              </div>
            </vab-col>
          </vab-row>
          <vab-row class="margin_8">
            <vab-col class="flex_center_align picker_label">
              <span class="tz_title">駐車利用</span>
            </vab-col>
            <vab-col>
              <div class="flex_start flex_center_align">
                <div class="radio_box">
                  <vab-radio-group
                    :ref="'parkFlg' + index"
                    class="margin_0"
                    :prop="`scheduleAdjDetailModelList.${index}.parkFlg`"
                    :code-enum="$divisions.necessaryFlagEnum"
                    filter="existFlag2"
                  />
                </div>
              </div>
            </vab-col>
          </vab-row>
        </vab-col>
      </vab-row>
    </vab-form>
    <div slot="footer" class="dialog-footer flex_end">
      <div class="flex_start flex_center_align">
        <!-- <div class="quxiao" @click="handleCancel">キャンセル</div> -->
        <el-button class="cancel" @click="handleCancel">キャンセル</el-button>
        <el-button class="changebtn w104" @click="handleConfirm">
          選択
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  let format = require('string-format')
  import mixinSchedule from '@/utils/mixinSchedule'
  export default {
    name: 'DaySc',
    mixins: [mixinSchedule],
    inject: {
      formData: { default: () => ({}) },
      setDrawTimeList: { default: () => ({}) },
      setInfoDateList: { default: () => ({}) },
    },
    data() {
      return {
        show: false,
        title: '',
        rules: {},
        form: {
          scheduleAdjDetailModelList: [],
        },
        rowIndex: -1,
        hbList: [
          {
            name: '断水時間',
            prefix: 'waterOff',
          },
          {
            name: '停電時間',
            prefix: 'electricOff',
          },
          {
            name: '回収希望時間',
            prefix: 'collection',
          },
        ],
      }
    },
    computed: {
      parentForm() {
        return this.formData()
      },
      validateStartTime() {
        return (row, item, index) => {
          if (this.checkEnumFlag(row[item.prefix + 'ExistFlag'])) {
            this.$set(
              this.rules,
              `scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`,
              [
                {
                  required: true,
                  validator: (rule, value, callback) =>
                    this.validatorStartTime(
                      rule,
                      value,
                      callback,
                      row,
                      item,
                      'StartTime'
                    ),
                  trigger: 'blur',
                },
              ]
            )
            this.$set(
              this.rules,
              `scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`,
              [
                {
                  required: true,
                  validator: (rule, value, callback) =>
                    this.validatorStartTime(
                      rule,
                      value,
                      callback,
                      row,
                      item,
                      'EndTime'
                    ),
                  trigger: 'blur',
                },
              ]
            )
          } else {
            row[`${item.prefix}StartTime`] = null
            row[`${item.prefix}EndTime`] = null
          }
        }
      },
      info() {
        return this.parentVm.info
      },
    },
    methods: {
      // 取消按钮
      handleCancel() {
        this.$refs.form.clearValidate()
        this.show = false
      },
      // 終日
      changeDayFlag(val, row) {
        if (val === this.$divisions.validFlgEnum.enum_1.value) {
          row.disabled = true
          row.startTime = null
          row.endTime = null
        } else {
          row.disabled = false
        }
      },
      // チェック時間です
      validatorStartTime(rule, value, callback, row, item, type) {
        value = row[item.prefix + type]
        if (
          this.checkEnumFlag(row[item.prefix + 'ExistFlag']) &&
          this.$baseLodash.isEmpty(value)
        ) {
          callback(
            new Error(
              format(
                this.$t(`validateMessage.${this.$messageCode.E00000001.name}`),
                'この項目'
              )
            )
          )
        } else {
          callback()
        }
      },
      //時間を選択する
      changeWattingDate(row, index, value) {
        // 日程が25日以降（25日含む）を選択の場合、アラートする
        // '後続業務に影響があるため、25日以降の日程を避けて頂きたいです。'
        if (this.$baseLodash.isEmpty(row.startDateTime)) {
          row.startDateTime = value
        }
        if (this.$baseLodash.isEmpty(row.endDateTime)) {
          row.endDateTime = value
        }
        let repeat = this.checkRepeatDate(
          row,
          this.rowIndex,
          this.parentForm.scheduleAdjDetailModelList
        )
        if (repeat) return
        // let checkDay = this.$dayjs(value).format('DD')
        // if (checkDay >= 25) {
        //   this.msgInfo(
        //     this.$t(`validateMessage.${this.$messageCode.W00000113.name}`)
        //   )
        // }
        // 4 納品月がずれる（工事日程）
        // 要望「工事予定連絡書確認(DLN)画面について協力会社が入力した日程を、メールでまずは受領できるようにし、重複する場合や納品月がずれる場合にアラートもらうような機能にしてほしい」から
        // 判断基準：「予定日程の最終日」が「納品月」を超える場合
        // 例えば：「納品月」が7月し、「予定日程の最終日」が8月1日以降（含む）
        let contractEndDate = this.getFieldValue(
          'demandBaseIdModel.contractEndDate',
          this.parentVm.info
        )
        if (
          !this.$baseLodash.isEmpty(contractEndDate) &&
          !this.$baseLodash.isEmpty(value) &&
          this.$dayjs(value).isAfter(this.$dayjs(contractEndDate))
        ) {
          this.msgInfo(
            this.$t(`validateMessage.${this.$messageCode.W00000218.name}`)
          )
        }
        // 2 重複する（事前調査と工事日程） #3175
        //  「SC1」の場合、デフォルト "4":調整済
        // でも、不可日または他の日程と重なるの時、"2":提出済（確認必要）
        // 以外の場合、"2":提出済
        // 「SC3」事前調査の場合、不可日を選択不可
        // if (
        //   this.isEqualCodeEnum(
        //     this.getFieldValue('demandType', this.parentVm.info),
        //     this.$divisions.demandTypeEnum.enum_1
        //   ) ||
        //   this.isEqualCodeEnum(
        //     this.getFieldValue('demandType', this.parentVm.info),
        //     this.$divisions.demandTypeEnum.enum_6
        //   )
        // ) {
        //   let isSame = false
        //   let noDayList = this.vm.noDayList
        //   noDayList.filter((item) => {
        //     if (!isSame) {
        //       if (this.$dayjs(item.date).isSame(value, 'day')) {
        //         isSame = true
        //       }
        //     }
        //   })
        //   if (isSame) {
        //     temp3 = true
        //   } else {
        //     temp3 = false
        //   }
        // } else {
        //   temp3 = false
        // }
        //「SC1」工事・作業、不可日を選択提醒
        if (
          (this.isEqualCodeEnum(
            this.getFieldValue('demandType', this.parentVm.info),
            this.$divisions.demandTypeEnum.enum_1
          ) ||
            this.isEqualCodeEnum(
              this.getFieldValue('demandType', this.parentVm.info),
              this.$divisions.demandTypeEnum.enum_6
            )) &&
          this.isEqualCodeEnum(
            this.getFieldValue(
              'requestIdModel.requestClass',
              this.parentVm.info
            ),
            this.$divisions.requestClassEnum.enum_2
          )
        ) {
          // let noDayList = this.vm.noDayList
          // if (
          //   noDayList.some((time) =>
          //     this.$dayjs(time.date).isSame(value, 'day')
          //   )
          // ) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000286.name}`)
          //   )
          // }
          // if (this.checkCalendar(value, this.vm.calendarList)) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000217.name}`)
          //   )
          //   temp4 = true
          // }
          this.checkDayReportRequest(row)
        }
        if (
          !this.$baseLodash.isEmpty(row.startDateTime) &&
          !this.$baseLodash.isEmpty(row.endDateTime)
        ) {
          let isSame = this.$dayjs(row.startDateTime).isSame(
            row.endDateTime,
            'day'
          )
          if (!isSame) {
            row.disabled = true
            row.startTime = null
            row.endTime = null
            row.checkDisabled = true
            // 終日値は空です
            if (this.checkEnumFlag(row.dayFlag)) {
              row.dayFlag = this.$divisions.validFlgEnum.enum_0.value
            }
          } else {
            row.disabled = false
            row.checkDisabled = false
            row.dayFlag = this.$divisions.validFlgEnum.enum_0.value
          }
        }
      },
      setWattingList(list) {
        if (list.length > 0) {
          let listData = list[0]
          let parentLen = this.parentForm.scheduleAdjDetailModelList.length
          if (parentLen - 1 < this.rowIndex) {
            this.parentForm.scheduleAdjDetailModelList.push(listData)
          } else {
            this.parentForm.scheduleAdjDetailModelList[this.rowIndex] = listData
          }
          this.$set(
            this.parentForm.scheduleAdjDetailModelList,
            this.rowIndex,
            listData
          )
          this.setInfoDateList(this.parentForm.scheduleAdjDetailModelList, true)
          this.setDrawTimeList(this.parentForm.scheduleAdjDetailModelList)
          this.$refs.form.clearValidate()
          this.show = false
          this.form.scheduleAdjDetailModelList = []
          this.rowIndex = -1
        }
      },
      // 确定按钮
      handleConfirm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.setWattingList(this.form.scheduleAdjDetailModelList)
          } else {
            return false
          }
        })
      },
      setFormList() {
        this.parentForm.scheduleAdjDetailModelList.filter((item, pindex) => {
          if (this.rowIndex == -1) {
            if (!item.startDateTime || !item.endDateTime) {
              this.rowIndex = pindex
            }
          }
        })
        if (this.rowIndex == -1) {
          this.rowIndex = this.parentForm.scheduleAdjDetailModelList.length
        }
        let data = this.$baseLodash.cloneDeep(
          this.parentForm.scheduleAdjDetailModelList[0]
        )
        delete data.scheduleAdjDetailId
        Object.keys(data).filter((key) => {
          data[key] = null
        })
        let mixData = {
          dayFlag: this.$divisions.validFlgEnum.enum_0.value, // 終日
          parkFlg: this.$divisions.existFlagEnum.enum_blank.value, //駐車利用
          waterOffExistFlag: this.$divisions.existFlagEnum.enum_blank.value,
          electricOffExistFlag: this.$divisions.existFlagEnum.enum_blank.value,
          collectionExistFlag: this.$divisions.existFlagEnum.enum_blank.value,
          disabled: true,
          checkDisabled: true,
        }
        data = { ...data, ...mixData }
        this.form.scheduleAdjDetailModelList = []
        this.form.scheduleAdjDetailModelList.push(data)
        this.setData(this.form.scheduleAdjDetailModelList.length - 1)
      },
      setData(index) {
        this.$nextTick(() => {
          this.hbList.filter((hbItem) => {
            setTimeout(() => {
              this.$refs[hbItem.prefix + index][0].setValue(
                this.$divisions.existFlagEnum.enum_blank.value
              )
              this.$refs['parkFlg' + index][0].setValue(
                this.$divisions.necessaryFlagEnum.enum_blank.value
              )
            }, 0)
          })
        })
      },
      // 初始化数据
      initData(data) {
        this.setFormList()
        if (data?.list) {
          this.rowIndex = data.list.filter((i) => i.type !== 'hope').length
        }
        this.title = '対応日程' + Number(this.rowIndex + 1)
        if (data?.vm) {
          this.vm = data.vm
        }
        if (data?.parentVm) {
          this.parentVm = data.parentVm
        }
        this.show = true
      },
    },
  }
</script>

<style lang="scss" scoped>
  .quxiao {
    font-weight: 500;
    font-size: 14px;
    color: #848484;
    padding: 0 30px;
    cursor: pointer;
  }
  .m20 {
    margin: 0 20px;
  }
  .w104 {
    width: 104px;
    height: 32px;
  }
  .mode {
    display: flex;
    align-items: center;
  }
  .sec80 {
    width: 80px;
  }
  .line {
    padding: 0 8px;
    font-size: 13px;
    color: #000000;
    display: inline-block;
  }
  .mode ::v-deep {
    .el-dialog__title {
      color: #003350;
      text-align: left;
    }
    .el-dialog__footer {
      border-top: none;
    }
    .el-dialog__body {
      padding-top: 20px;
    }
  }
</style>
